import { attach, createEffect } from 'effector';
import { getAuthMe, postAuthPasswordReset, postAuthRefresh } from '~/generated/authBackend/auth';
import {
    GetAuthMeVerbose,
    type InternalApiHttpAuthGetMeResponse,
    type InternalApiHttpAuthPasswordResetRequest,
    type InternalApiHttpAuthRefreshResponse,
} from '~/generated/authBackend/model';
import { getTokens, setTokens } from './lib/storage';

export const getMeFx = createEffect<void, InternalApiHttpAuthGetMeResponse>(async () => {
    return await getAuthMe(
        {
            verbose: GetAuthMeVerbose.all,
            app: 'Unite',
        },
        {
            context: {
                skipErrorNotification: true,
            },
        },
    );
});

export const resetPasswordFx = createEffect<InternalApiHttpAuthPasswordResetRequest, void>(async (payload) => {
    await postAuthPasswordReset(payload);
});

export const refreshTokenFx = createEffect<void, InternalApiHttpAuthRefreshResponse>(async () => {
    return await postAuthRefresh();
});

export const getMeWithSessionFx = attach({
    effect: getMeFx,
});

export const loadTokenFx = createEffect(async (): Promise<string | null> => {
    const { accessToken } = await getTokens();

    return accessToken;
});

export const saveTokenFx = createEffect(async (accessToken: string) => {
    const tokens = await getTokens();

    await setTokens({
        ...tokens,
        accessToken,
    });
});

export const clearTokenFx = createEffect(async () => {
    const tokens = await getTokens();

    await setTokens({
        ...tokens,
        accessToken: null,
    });
});
